import { render } from "./IconRemove.vue?vue&type=template&id=23335280"
import script from "./IconRemove.vue?vue&type=script&lang=js"
export * from "./IconRemove.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__